import { UsersSortBy } from '../pages/Users/Users.types';
import { IPageInfo } from './page.types';

export interface UserM {
  firstName: string;
  lastName: string;
  pesel: string;
  phone: string;
  phoneHidden: boolean;
  email: string;
  accountTypeId: AccountTypeEnum;
  accountTypeName: string;
  examCommittee: string;
  examCommitteeShortName: string;
  examCommitteeId: number;
  expirationDate: Date;
  isOnline: boolean;
  emailConfirmed: boolean;
  id: number;
  domainEvents?: any;
  forcedPasswordChange?: boolean;
}

export type UserSortBy =
  | 'firstName'
  | 'lastName'
  | 'pesel'
  | 'phone'
  | 'email'
  | 'examCommitteeShortName'
  | 'accountTypeName'
  | 'emailConfirmed';

export interface IUserEvent {
  securityEventType: 'UserModified' | 'UserCreated';
  timeStamp: string;
  user: UserM;
  userId: number;
  content: string;
  submitter: UserM;
  submitterId: number;
}

export type AccountTypeName = 'Administrator' | 'Egzaminator' | 'Pracownik komisji egzaminacyjnej';
export const accountTypes: readonly AccountTypeName[] = [
  'Administrator',
  'Egzaminator',
  'Pracownik komisji egzaminacyjnej',
];

export enum AccountTypeEnum {
  Administrator = 1,
  Examiner = 2,
  ExamCommitteeEmployee = 3,
}

export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  pesel: string;
  phone: string;
  email: string;
  accountTypeId: AccountTypeEnum;
  examCommitteeId: number;
  expirationDate: string;
  isBlocked: boolean;
  isOnline: boolean;
  emailConfirmed: boolean;
  passwordLastUpdate: string | null;
}

export interface IUsersResponse {
  total: number;
  page: IPageInfo;
  filter: {
    firstName: string | null;
    lastName: string | null;
    pesel: string | null;
    phone: string | null;
    email: string | null;
    accountTypeFilter: null;
    examCommitteeFilter: null;
    expirationDate: null;
    isOnline: null;
    emailConfirmed: null;
  };
  sort: {
    property: UsersSortBy;
    isDescending: boolean;
  };
  userList: IUser[];
}
export enum UserDeleteStatus{
  Success,
  AlreadyAssignedToSession,
  NotExist,
  Error
}
export enum UserPasswordStatus {
  Expired = 0,
  ForcedChange = 1
}

export enum ImportUsersStatus {
  WrongFileExtension,
  EmptyOrWrongFileContent,
  Failed,
  Success,
}

export const getAccountTypeLabel = (accTypeId: AccountTypeEnum | null) => {
  switch (accTypeId) {
    case AccountTypeEnum.Administrator:
      return 'Administrator';
    case AccountTypeEnum.Examiner:
      return 'Egzaminator';
    case AccountTypeEnum.ExamCommitteeEmployee:
      return 'Pracownik komisji egzaminacyjnej';
  }
};

export const getAccountTypeId = (accTypeLabel: string): AccountTypeEnum | null => {
  switch (accTypeLabel) {
    case 'Administrator':
      return AccountTypeEnum.Administrator;
    case 'Egzaminator':
      return AccountTypeEnum.Examiner;
    case 'Pracownik komisji egzaminacyjnej':
      return AccountTypeEnum.ExamCommitteeEmployee;
    default:
      return null;
  }
};
